import { render } from "./CustomerMasterDataManager.vue?vue&type=template&id=a8530a8c"
import script from "./CustomerMasterDataManager.vue?vue&type=script&lang=js"
export * from "./CustomerMasterDataManager.vue?vue&type=script&lang=js"

import exportComponent from "D:\\PHPStormProjects\\hqam-customer-portal\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__